import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import * as moment from 'moment'
import * as CryptoJS from "crypto-js";


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { } 
  
  public static chromeid = 'icjcecoafmlannickbnokaahkfomllcf' //rohan chromid

  public static emailPattern = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

  public static getDates(date: any): any {
    var date1 = new Date(date);
    var date2 = new Date(moment(new Date()).format("YYYY-MM-DD"));

    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays == 1 && moment(date1).format("YYYY-MM-DD") == moment(date2).format("YYYY-MM-DD")) {
      return { text: "Today", type: "day", value: diffDays, urgency: false };
    }
    else if (diffDays < 30) {
      if (diffDays >= 1 && diffDays <= 3)
        return { text: diffDays + " days", type: "day", value: diffDays, urgency: false }
      else
        return { text: diffDays + " days", type: "day", value: diffDays, urgency: true }
    }
    else if (diffDays > 30) {
      var diff = (date2.getTime() - date1.getTime()) / 1000;
      diff /= (60 * 60 * 24 * 7 * 4);
      var months = Math.abs(Math.round(diff));
      return { text: months + " months", type: "month", value: months, urgency: true }
    }
    else {
      return { text: "today", type: "day", value: diffDays, urgency: false };
    }
  }

  public static handleError(operation: String, url: string) {
    return (err: any) => {
      let errMsg = `error in ${operation}() retrieving ${url}`;
      console.log(`${errMsg}:`, err)
      if (err.status === 0 && !url.includes('candidate/bulkgrab'))
        window.location.href = '/login'
      // window.location.href = '/server-error'
      if (err.status === 401){
        localStorage.clear();
        sessionStorage.clear();
        let visitedURL = window.location.href.replace(window.location.origin,"")
        if (visitedURL && visitedURL != "null" && visitedURL != "undefined" && !visitedURL.includes('signup') && !visitedURL.includes('login')){
            window.location.href = `/login?redirect=${visitedURL}`
        }else{
            window.location.href = '/login'
        }
      }
      // if (err.status === 404)
      //   window.location.href = '/login'
      // window.location.href = '/error404'
      return throwError(errMsg);
    }
  }

  public static months = [{ id: '01', name: 'January' }, { id: '02', name: 'February' }, { id: '03', name: 'March' }, { id: '04', name: 'April' }, { id: '05', name: 'May' }, { id: '06', name: 'June' }, { id: '07', name: 'July' }, { id: '08', name: 'August' }, { id: '09', name: 'September' }, { id: '10', name: 'October' }, { id: '11', name: 'November' }, { id: '12', name: 'December' }]
  
  public static dateFormat(day: any, month: any, year: any) {
    return year + "-" + month + "-" + day;
}
  public static yearList() {
    var currentdate = new Date()
    currentdate.setFullYear(currentdate.getFullYear())
    let year_list = []
    for (let i = 0; i <= 100; i++) {
      year_list.push(currentdate.getFullYear())
      currentdate.setFullYear(currentdate.getFullYear() - 1)
    }
    return year_list;
  }
  
  public static placeholderlist = [
    { value: "candidate.firstname", type: 'candidate' },
    { value: "candidate.lastname", type: 'candidate' },
    { value: "candidate.currentjobtitle", type: 'candidate' },
    { value: "candidate.currentcompany", type: 'candidate' },
    { value: "candidate.currentlocation", type: 'candidate' },
    { value: "user.firstname", type: 'user' },
    { value: "user.emailid", type: 'user' },
    { value: "user.lastname", type: 'user' },
  ]


  public static toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  public static SourceList = ['linkedin','monster','naukri','other']

  public static PipelineStatus = ['Hot','Warm','Cold']

  public static decryptData(data: any): any {
    var enc_key = CryptoJS.enc.Base64.parse("#base64Key#");
    var enc_iv = CryptoJS.enc.Base64.parse("#base64IV#");
    if (typeof data === 'string') {
        data = data.replace(/xMl3Jk/g, '+' ).replace(/Por21Ld/g, '/').replace(/Ml32/g, '=')
    }
    let enc_data = CryptoJS.AES.encrypt(data, enc_key, { iv: enc_iv });
    if (enc_data) {
        let dec_data = CryptoJS.AES.decrypt(enc_data, enc_key, { iv: enc_iv }).toString(CryptoJS.enc.Utf8)
        if (dec_data) {
            return CryptoJS.AES.decrypt(dec_data, enc_key, { iv: enc_iv }).toString(CryptoJS.enc.Utf8)
        } else {
            return null;
        }
    } else {
        return null;
    }
  }

  public static convertToK(number) {
    // console.log(number, 'efefefefef')
    if(number != null){
      const suffixes = ['', 'K', 'M', 'B', 'T']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    }else{
      number = 0;
    }
  }

  public static seniorityLevels = ["cxo","director","entry","manager","owner","partner","senior","training","unpaid","vp"]

  public static buildQueryString(data){
    const queryString = Object.keys(data)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
  .join('&');

  return queryString;

  }
  public static searchType = ["quick-search", "advanced-search", "jd-search", "similar-candidates-linkedin", "similar-candidates-resume"]

  public static getIndustryIcon(name){
    const industriesIcons = {
      "financial services": "sack-dollar",
      "oil & energy": "oil-well",
      "retail": "cart-shopping",
      "utilities": "fire-flame",
      "insurance": "shield-check",
      "information technology and services": "display-code",
      "automotive": "car-wrench",
      "hospital & health care": "suitcase-medical",
      "chemicals": "flask-vial",
      "consumer goods": "bags-shopping",
      "food & beverages": "burger-soda",
      "internet": "globe",
      "construction": "user-helmet-safety",
      "semiconductors": "microchip-ai",
      "mining & metal": "axe",
      "building materials": "trowel-bricks",
      "pharmaceuticals": "capsules",
      "transportation/trucking/railroad": "truck-fast",
      "biotechnology": "dna",
      "electrical/electronic manufacturing": "computer-speaker",
      "packaging and containers": "boxes-packing",
      "real estate": "house-building",
      "telecommunications": "phone-volume",
      "airlines/aviation": "plane"
    }
    if(industriesIcons[name] != null){
      return industriesIcons[name]
    }

    return 'industry'

  }


  public static getPersonSearchActivityText(activity) {
    if(activity.activitytype == 'Talentpool' && activity.action == 'add'){
      return `Added to talentpool - <a class="redirect" href="/talentpool/details/${activity?.talentpoolid}" target="_blank"> ${activity.name} </a>`
    }else if(activity.activitytype == 'Contact Revealed' && activity.action == 'create'){
      if(activity.name.toString().includes('pdl')){
        return 'Contact Revealed - Pdl'
      }else if(activity.name.toString().includes('pipl')){
        return 'Contact Revealed - Pipl'
      }else if(activity.name.toString().includes('pipl')){
        return 'Contact Revealed - Pipl'
      }else if(activity.name.toString().includes('rocket')){
        return 'Contact Revealed - Rocket Reach'
      }else if(activity.name.toString().includes('nymblr')){
        return 'Contact Revealed - Nymblr'
      }else if(activity.name.toString().includes('Webbtree Verified')){
        return 'Contact Requested - Webbtree Verified '
      }else if(activity.name.toString().includes('Webbtree Introduction')){
        return 'Introduction Requested '
      }
    }else if(activity.activitytype == 'Contact Revealed' && activity.action == 'added'){
      return `Candidate has been created from Talent Discovery` 
    }else if(activity.activitytype == 'Email Campaigns'){
      return `Added to Email Campaign - ${activity.name}`
    }else if(activity.activitytype == 'Profile Viewed'){
      return `Profile Viewed - ${activity.username}`
    }
  }


  
  public static getProvidername(key){
    if(key != null){
      if(key.toString().toLowerCase() === 'pipl'){
        return 'Pipl'
      }else if(key.toString().toLowerCase() === 'pdl'){
        return 'People Data Labs'
      }else if(key.toString().toLowerCase() === 'rocketreach'){
        return 'RocketReach'
      }else if(key.toString().toLowerCase() === 'nymblr'){
        return 'Nymblr'
      }else if(key.toString().toLowerCase() == 'webbtree introduction'){
        return 'Webbtree Introduction'
      }else if(key.toString().toLowerCase() == 'webbtree verified'){
        return 'Webbtree Verified'
      }
    }
  }

  public static getUpdateDates(date: any): any {
    var date1 = new Date(date);
    var date2 = new Date(moment(new Date()).format("YYYY-MM-DD"));

    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays == 1 && moment(date1).format("YYYY-MM-DD") == moment(date2).format("YYYY-MM-DD")) {
      return { text: "Today", type: "day", value: diffDays, urgency: false };
    }
    else if (diffDays < 30) {
      if (diffDays >= 1 && diffDays <= 3)
        return { text: diffDays + " days", type: "day", value: diffDays, urgency: false }
      else
        return { text: diffDays + " days", type: "day", value: diffDays, urgency: true }
    }
    else if (diffDays > 30 && diffDays < 365) {
      var diff = (date2.getTime() - date1.getTime()) / 1000;
      diff /= (60 * 60 * 24 * 7 * 4);
      var months = Math.abs(Math.round(diff));
      if(months > 1)
        return { text: months + " mths", type: "month", value: months, urgency: true }
      else
      return { text: months + " mth", type: "month", value: months, urgency: true }
    } 
    else if (diffDays > 365) {
      var enddate = moment();
      var startdate = moment(date);
    //  var diff = (date2.getTime() - date1.getTime()) / 1000;
      var yearsDiff = enddate.diff(startdate, 'years');
      var startDatePlusYears = startdate.add(yearsDiff, 'years');
      var monthsDiff = enddate.diff(startDatePlusYears, 'months');
      if(monthsDiff >= 1) 
        return { text: yearsDiff + " yrs " + monthsDiff + ' mths', type: "year", value: yearsDiff, urgency: true };
      else
      return { text: yearsDiff + " yrs", type: "year", value: yearsDiff, urgency: true };
    } else {
      return { text: "today", type: "day", value: diffDays, urgency: false };
    }
  }

  public static generateUniqueId(): string {
    return Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);
  }

  public static getAllCandidateActivityText(activity) {
    if(activity.toString().includes('pdl')){
      return 'Contact Revealed - Pdl'
    }else if(activity.toString().includes('pipl')){
      return 'Contact Revealed - Pipl'
    }else if(activity.toString().includes('pipl')){
      return 'Contact Revealed - Pipl'
    }else if(activity.toString().includes('rocket')){
      return 'Contact Revealed - Rocket Reach'
    }else if(activity.toString().includes('numblr')){
      return 'Contact Revealed - Numblr'
    }else if(activity.toString().includes('Webbtree Verified')){
      return 'Contact Requested - Webbtree Verified '
    }else if(activity.toString().includes('Webbtree Introduction')){
      return 'Introduction Requested'
    }
  }
  
  /**
   * Function will truncate the given string from middle
   * @param str Given string to truncate
   * @param maxLength maxLength after truncate
   * @returns trucated string
   */
  public static truncateFromMiddle(str, maxLength = 20) {
    if (str.length <= maxLength) {
      return str;
    }
  
    const halfLength = Math.floor((maxLength - 3) / 2);
    const start = str.substr(0, halfLength);
    const end = str.substr(-halfLength);
  
    return `${start}...${end}`;
  }


  /**
   * Convert string to titlecase format
   * @param inputString 
   */
  public static titleCase(inputString: string) {
    if(typeof inputString !== 'string') return '';
    if ((inputString === null) || (inputString === '')) return '';

    return inputString.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}
}
